import {Link, useNavigate, useParams} from "react-router-dom";
import React, {ReactComponentElement, useEffect, useState} from "react";
import {ActivationType, resendToken, validateToken} from "../../features/activation/activationApi";
import {Box, IconButton, Typography} from "@mui/material";
import {Button, Card, Spacer, TextField} from "../../common";
import TryAgainButton from "./TryAgainButton";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import I18n from "i18n-js";

export interface ActivationProps {
  onActivationSuccess: Function;
  type: ActivationType;
  email: string;
  message: ReactComponentElement<any>;
  contentOnly?: boolean;
}

export default function Activation({onActivationSuccess, type, email, message, contentOnly = false}: ActivationProps) {
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string>("");
  const [token, setToken] = useState<string>("");

  async function process() {
    setError("");
    setLoading(true);
    // @ts-ignore it's not possible to call the process if the type is not set anyway.
    const response = await validateToken(token.replace(/\s+/g, ''), type);
    const data = response.data;
    setLoading(false);

    if (!data.success) {
      setError(I18n.t("Activation.invalidToken"));
      return;
    } else {
      onActivationSuccess(token.replace(/\s+/g, ''));
    }
  }

  function getContent() {
    return (
      <>
        <Typography variant="h3" align="center">
          {I18n.t("Activation.enterCode")}
        </Typography>
        <Spacer h={1}/>
        <Typography variant="body1" align="center">
          {I18n.t("Activation.codeSentTo", {
            email
          })}
        </Typography>
        {message}
        <Spacer h={1}/>
        <TextField
          error={error}
          value={token}
          onChange={(evt: any) => {
            setError("");
            setToken(evt.target.value);
          }}
          sx={{width: "100%"}}
          mask={"0 0 0 0 0 0"}
          label={"Activation code"}
        />
        <Button
          variant="contained"
          sx={{
            width: "100%",
            marginTop: 2,
          }}
          onClick={() => {
            process();
          }}
          loading={loading}
        >
          Confirm
        </Button>
        <Spacer h={1}/>
        <Typography variant="body1" align="center">
          {I18n.t("Activation.didntReceiveCode")}
          {" "}
          <TryAgainButton
            onClick={() => {
              resendToken(email, type);
            }}
            disabled={loading}
          />
        </Typography>
      </>
    );
  }

  if (contentOnly) {
    return getContent();
  }

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        margin: "0 auto",
        padding: 2,
      }}
    >

      <Card
        sx={{
          minWidth: "400px",
        }}
      >
        <Link to={"/login"}>
          <IconButton>
            <ChevronLeftIcon />
          </IconButton>
        </Link>

        {getContent()}

      </Card>
    </Box>
  );
}